import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import Layout from "../Common/Layout";
import { changePassword } from "../../actions/user.actions";
import ChangePasswordForm from "./ChangePasswordForm";

export class ChangePassword extends PureComponent {
  onSubmit = data => {
    this.props.dispatch(changePassword(this.props.currentUser.id, data));
  };

  render() {
    return (
      <Layout.Page>
        <Layout.Header title="Change Password" />
        <Layout.Content>
          <ChangePasswordForm onSubmit={this.onSubmit} edit={true} changePassword={true} />
        </Layout.Content>
      </Layout.Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  currentUser: get(state, "common.currentUser"),
  inProgress: get(state, "common.inProgress")
});
export default connect(mapStateToProps)(ChangePassword);
